<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p>All she wanted to do was write. It was her only real outlet, her only real escape. It was cathartic, necessary. She knew she ought to be doing other things, attending to arguably more pressing matters but she could not help it. This was the catalyst. Without it, she felt as if there was no next level – trapped inside her own mind and stifled by the lack of movement. She broke through, however. She decided that doing something she loved, something definitive, was better than doing nothing at all. Of course, as she wrote it, she realised how obvious this was. It made sense to her. Probably not to anyone else but at least to her. That was enough.</p><br/>
<p style="text-align: center;">*It must be written*</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?d3be2106